import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    type SelectChangeEvent,
} from '@mui/material';
import { useId } from 'react';

interface Option {
    label: string;
    value: number;
    disabled?: boolean;
}

interface Props {
    label: string;
    options: Option[];
    value: number | null;
    onChange: (value: number) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: string;
}

export default function IDVCustomSelect({
    label,
    options,
    value,
    onChange,
    disabled = false,
    error,
}: Props) {
    const selectId = useId();

    return (
        <FormControl fullWidth required error={!!error} disabled={disabled}>
            <InputLabel id={selectId}>{label}</InputLabel>
            <Select
                labelId={selectId}
                label={label}
                value={value ?? ''}
                sx={{ backgroundColor: 'white' }}
                onChange={(event: SelectChangeEvent<number>) => {
                    onChange(Number(event.target.value));
                }}
            >
                {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value} disabled={opt.disabled}>
                        {opt.label}
                    </MenuItem>
                ))}
            </Select>
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
}
